import { defineComponent as oe, useSlots as te, ref as d, computed as u, watch as m, nextTick as A, onMounted as ne, onBeforeUnmount as le, provide as S, openBlock as g, createElementBlock as y, normalizeClass as ae, withModifiers as ie, renderSlot as F, createCommentVNode as H, createVNode as I, Transition as N, withCtx as D, withDirectives as $, vShow as W, normalizeStyle as j, createElementVNode as se, unref as de } from "vue";
import ue from "../../directives/trapFocus.mjs";
import P from "../config.mjs";
import { toCssWidth as re, createAbsoluteElement as ce, removeElement as fe, isCustomElement as pe } from "./helper.mjs";
const ve = ["tabindex"], me = ["aria-hidden"], ge = ["aria-hidden"], ye = ["role", "aria-modal"], xe = /* @__PURE__ */ oe({
  __name: "IstDropdown",
  props: {
    modelValue: { type: [String, Number, Boolean, Object, Array, Function, null], default: null },
    disabled: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: void 0 },
    scrollable: { type: Boolean, default: void 0 },
    maxHeight: { default: 200 },
    position: { default: "is-bottom-right" },
    triggers: { default: () => [
      0
      /* click */
    ] },
    mobileModal: { type: Boolean, default: () => P.defaultDropdownMobileModal },
    ariaRole: { default: null },
    animation: { default: "fade" },
    multiple: { type: Boolean, default: void 0 },
    trapFocus: { type: Boolean, default: () => P.defaultTrapFocus },
    closeOnClick: { type: Boolean, default: !0 },
    canClose: { type: [Array, Boolean], default: !0 },
    expanded: { type: Boolean, default: void 0 },
    appendToBody: { type: Boolean, default: !0 },
    appendToBodyCopyParent: { type: Boolean, default: void 0 },
    triggerTabindex: { default: 0 }
  },
  emits: ["change", "input", "update", "active-change", "update:modelValue"],
  setup(z, { expose: R, emit: U }) {
    const X = ue, o = z, E = te(), k = E.default ? E.default() : null, Y = ["escape", "outside"], n = d([]), O = d({}), t = d(!1), c = d(!1), v = d(), h = d(), f = d(), p = d(), s = U;
    u(() => k ? k.reduce((a, l, x) => {
      var i;
      return l.type.__name !== "IstDropdownItem" || (console.log(l, (i = l.props) == null ? void 0 : i.value), l.props && l.props.value && (a[l.props.value] = {
        value: l.props.value
      })), a;
    }, {}) : {});
    const L = u(() => [
      o.position,
      {
        "is-disabled": o.disabled,
        "is-hoverable": w.value,
        "is-inline": o.inline,
        "is-active": t.value || o.inline,
        "is-mobile-modal": b.value,
        "is-expanded": o.expanded
      }
    ]), b = u(() => o.mobileModal && !o.inline), T = u(() => typeof o.canClose == "boolean" ? o.canClose ? Y : [] : o.canClose), q = u(() => ({
      maxHeight: o.scrollable ? re(o.maxHeight) : null,
      overflow: o.scrollable ? "auto" : null
    })), w = u(() => o.triggers.indexOf("hover") >= 0), G = function() {
      typeof window > "u" || b.value && (t.value ? document.documentElement.classList.add("is-clipped-touch") : document.documentElement.classList.remove("is-clipped-touch"));
    }, J = function(e) {
      o.multiple ? (Array.isArray(n.value) ? n.value.indexOf(e) === -1 ? n.value = [...n.value, e] : n.value = n.value.filter((a) => a !== e) : n.value = [e], s("change", n.value)) : n.value !== e && (n.value = e, s("change", n.value)), s("input", n.value), o.multiple || (t.value = !o.closeOnClick, w.value && o.closeOnClick && (c.value = !1));
    }, M = function(e) {
      T.value.indexOf("outside") < 0 || o.inline || pe(e.target) || (t.value = !1);
    }, V = function({ key: e }) {
      if (t.value && (e === "Escape" || e === "Esc")) {
        if (T.value.indexOf("escape") < 0)
          return;
        t.value = !1;
      }
    }, K = function() {
      o.triggers.indexOf(
        0
        /* click */
      ) < 0 || B();
    }, Q = function() {
      o.triggers.indexOf(
        2
        /* contextmenu */
      ) < 0 || B();
    }, Z = function() {
      o.triggers.indexOf(
        1
        /* hover */
      ) < 0 || (c.value = !0);
    }, ee = function() {
      o.triggers.indexOf(
        3
        /* focus */
      ) < 0 || B();
    }, B = function() {
      o.disabled || (t.value ? t.value = !t.value : A(() => {
        const e = !t.value;
        t.value = e, setTimeout(() => t.value = e);
      }));
    }, _ = function() {
      if (f.value && p.value) {
        const e = v.value.children[0];
        if (e.classList.forEach((i) => e.classList.remove(i)), e.classList.add("dropdown"), e.classList.add("dropdown-menu-animation"), L.value.forEach((i) => {
          if (i && typeof i == "object")
            for (let r in i)
              i[r] && e.classList.add(r);
        }), o.appendToBodyCopyParent) {
          const i = h.value.parentNode, r = v.value;
          r.classList.forEach((C) => r.classList.remove(C)), i.classList.forEach((C) => {
            r.classList.add(C);
          });
        }
        const a = p.value.getBoundingClientRect();
        let l = a.top + window.scrollY, x = a.left + window.scrollX;
        !o.position || o.position.indexOf("bottom") >= 0 ? l += p.value.clientHeight : l -= f.value.clientHeight, o.position && o.position.indexOf("left") >= 0 && (x -= f.value.clientWidth - p.value.clientWidth), O.value = {
          position: "absolute",
          top: `${l}px`,
          left: `${x}px`,
          zIndex: "99",
          width: o.expanded ? `${h.value.offsetWidth}px` : void 0
        };
      }
    };
    return u({
      get() {
        return console.log("get", o.modelValue), o.modelValue;
      },
      set(e) {
        s("update:modelValue", e);
      }
    }), m(t, function(e) {
      s("active-change", e), G(), o.appendToBody && A(() => {
        _();
      });
    }), m(
      () => o.modelValue,
      function(e) {
        console.log("modelValue", e), n.value = e;
      }
    ), m(n.value, function(e) {
      console.log("selected", e), o.multiple ? s("update:modelValue", e) : Array.isArray(e) && e.length > 0 ? s("update:modelValue", e[0]) : s("update:modelValue", void 0);
    }), m(c, function(e) {
      w.value && s("active-change", e);
    }), typeof window < "u" && (document.addEventListener("click", M), document.addEventListener("keyup", V)), ne(() => {
      o.appendToBody && (v.value = ce(f.value), _());
    }), le(() => {
      typeof window < "u" && (document.removeEventListener("click", M), document.removeEventListener("keyup", V)), o.appendToBody && fe(v.value);
    }), S("selected", n.value), S("props", o), R({
      selectItem: J
    }), (e, a) => (g(), y("div", {
      ref_key: "dropdown",
      ref: h,
      class: ae(["dropdown dropdown-menu-animation", L.value]),
      onMouseleave: a[0] || (a[0] = (l) => c.value = !1)
    }, [
      e.inline ? H("", !0) : (g(), y("div", {
        key: 0,
        ref_key: "trigger",
        ref: p,
        tabindex: e.disabled ? -1 : e.triggerTabindex,
        class: "dropdown-trigger",
        "aria-haspopup": "true",
        onClick: K,
        onContextmenu: ie(Q, ["prevent"]),
        onMouseenter: Z,
        onFocusCapture: ee
      }, [
        F(e.$slots, "trigger", { active: t.value }, void 0, !0)
      ], 40, ve)),
      I(N, { name: e.animation }, {
        default: D(() => [
          b.value ? $((g(), y("div", {
            key: 0,
            class: "background",
            "aria-hidden": !t.value
          }, null, 8, me)), [
            [W, t.value]
          ]) : H("", !0)
        ]),
        _: 1
      }, 8, ["name"]),
      I(N, { name: e.animation }, {
        default: D(() => [
          $((g(), y("div", {
            ref_key: "dropdownMenu",
            ref: f,
            class: "dropdown-menu",
            style: j(O.value),
            "aria-hidden": !t.value
          }, [
            se("div", {
              class: "dropdown-content",
              role: e.ariaRole,
              "aria-modal": !e.inline,
              style: j(q.value)
            }, [
              F(e.$slots, "default", {}, void 0, !0)
            ], 12, ye)
          ], 12, ge)), [
            [W, !e.disabled && (t.value || c.value) || e.inline],
            [de(X)]
          ])
        ]),
        _: 3
      }, 8, ["name"])
    ], 34));
  }
});
export {
  xe as default
};
